import { WORDS_SINGULAR_PLURAL_MAPPING } from "./constants";

export const hyphenatedStringToReadable = (string) =>
  string
    .toLowerCase()
    .replaceAll(/\-s\-/g, "'s-")
    .replace(/(?:^|[\s-/])\w/g, (match) => match.toUpperCase())
    .replaceAll("-", " ");

export const pluralizeWord = (word, { count }) =>
  count > 1 ? WORDS_SINGULAR_PLURAL_MAPPING[word] : word;

export const parseRange = (range) => {
  const updatedRange = range || "";
  const qtyRange = updatedRange.split("..");
  const minRange = Number(qtyRange[0]);
  const maxRange = Number(qtyRange[1]);

  return { minRange, maxRange: Number.isNaN(maxRange) ? 10000 : maxRange };
};

export const decodeBase64ToString = (str) => {
  if (!str || str.trim() === "") {
    return null;
  }
  try {
    return window.atob(str);
  } catch (e) {
    return null;
  }
};

export const joinWithSeparators = (items, separator, lastSeparator) => {
  if (!items.length) {
    return "";
  }
  if (items.length === 1) {
    return items[0];
  }
  return items.reduce((str, item, index) => {
    const getSeparator = () => {
      if (index === items.length - 1) return lastSeparator;
      if (index !== 0) return separator;
      return "";
    };
    return `${str}${getSeparator()}${item.toUpperCase()}`;
  }, "");
};
